import {
  HeadingText,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import React from 'react';

export const LabelValueItem = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <StackLayout orientation="vertical" spacing="$half">
    <HeadingText level="3" size="xs" css={{ typography: '$label' }}>
      {label}
    </HeadingText>
    <ParagraphText size="sm" emphasis="subtle">
      {children}
    </ParagraphText>
  </StackLayout>
);
